import { render, staticRenderFns } from "./GameScreenDt.vue?vue&type=template&id=58111fdc&"
import script from "./GameScreenDt.vue?vue&type=script&lang=js&"
export * from "./GameScreenDt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports